import { render, staticRenderFns } from "./safeSearch.vue?vue&type=template&id=7463415e&scoped=true&"
import script from "./safeSearch.vue?vue&type=script&lang=js&"
export * from "./safeSearch.vue?vue&type=script&lang=js&"
import style0 from "./safeSearch.vue?vue&type=style&index=0&id=7463415e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463415e",
  null
  
)

export default component.exports